// extracted by mini-css-extract-plugin
export default {"listSearch":"GroupsMenuSearch_listSearch__5sqYi","search":"GroupsMenuSearch_search__oHUZS"};